
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-integrations/google-sheets",
      function () {
        return require("private-next-pages/whatsapp-integrations/google-sheets.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-integrations/google-sheets"])
      });
    }
  